import React from 'react';
import { ListItem, ListItemText } from '@material-ui/core';
import DragHandleIcon from '@mui/icons-material/DragHandle';

import makeSortableItem from 'retired/SortableItem';
import { purpleish, purple } from 'utils/color-styles';

const ContentListItem: React.FC<{
  content: { label: string; index: number };
}> = ({ content: { label, index } }) => (
  <ListItem
    key={label}
    style={{
      backgroundColor: purpleish,
      borderRadius: 16,
      paddingTop: 16,
      paddingBottom: 16,
      cursor: 'move',
      pointerEvents: 'none',
    }}
  >
    <ListItemText
      primary={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1 }}>{label}</div>
          <DragHandleIcon style={{ flex: 2, color: purple }} />
          <div style={{ flex: 1, textAlign: 'end' }}>{index}</div>
        </div>
      }
    />
  </ListItem>
);

export default makeSortableItem({
  itemType: 'content',
  wrapperStyle: {
    position: 'relative',
    maxWidth: 1000,
    padding: 0,
    marginBottom: 10,
    cursor: 'move',
  },
})(ContentListItem);
